import { render, staticRenderFns } from "./SubNav.vue?vue&type=template&id=083283c3&scoped=true"
import script from "./SubNav.vue?vue&type=script&lang=ts"
export * from "./SubNav.vue?vue&type=script&lang=ts"
import style0 from "./subNav.css?vue&type=style&index=0&id=083283c3&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083283c3",
  null
  
)

export default component.exports